// extracted by mini-css-extract-plugin
export default {"shareSNS-container":"ShareSNS_shareSNS-container__WuTMo","share-button":"ShareSNS_share-button__y5QVa","share-img":"ShareSNS_share-img__vLy4f"};